//form fields
ui.formFieldRating = function(){
    var scope = ".js-form-field-rating";
    ui.ready(
        scope,
        function($field){
            $field.find(scope+"__item").each(
                function(){
                    var value=$field.find(":input").val();
                    var n = $(this).data("number");
                    if(value==99)
                        $(this).removeClass("is-selected");
                    else
                        $(this).toggleClass("is-selected",n<=value);

                }
            );
            $field.find(scope+"__item").click(
                function(ev){
                    ev.preventDefault();
                    var numSel = $(this).data("number");
                    if(numSel<99)
                        $(this).addClass("is-selected");
                    else
                        $(this).toggleClass("is-selected");
                    var esSel = $(this).hasClass("is-selected");
                    $field.find(":input").val(numSel);
                    $field.find(scope+"__item").each(
                        function(){
                            var n = $(this).data("number");
                            if(numSel==99){
                                if(n<99 && esSel)
                                    $(this).removeClass("is-selected");
                            }else
                                $(this).toggleClass("is-selected",n<=numSel);
                        }
                    );
                    $field.trigger("formField:changeVal");
                }
            );

            $field.data(
                "funcGetVal",
                function(){
                    if($field.find(":input").val()==99)
                       return "";
                    else
                       return $field.find(":input").val();
                }
            );
        }
    );



}();